import React, { useState } from 'react'
import { TrackerProps } from '../../types'
import { UpdateSchedule } from '../shared/UpdateSchedule'
import { ActiveCasesTable } from './ActiveCasesTable'
import {
    StyledFlexLinkRow,
    StyledGridItem,
    StyledGridTitleItem,
    StyledJabTrackerContainer,
    StyledLink,
    StyledScheduleLink,
    StyledTitle,
} from './JabTracker.styled'

const theWestImageSM = require('./assets/thewest_covidtracker-sm.png')
const theWestImageLG = require('./assets/thewest_covidtracker-lg.png')

export function TWJabTracker({
    containerRatios,
    isLoading,
    isError,
    data,
    type,
}: TrackerProps) {
    const [scheduleOpen, setScheduleOpen] = useState(false)
    return (
        <StyledJabTrackerContainer
            containerRatios={containerRatios}
            isLoading={isLoading || isError}
            type={type}
        >
            <StyledGridTitleItem type={type}>
                <StyledTitle>COVID-19 TRACKER</StyledTitle>
                <img
                    className="jabtracker-image"
                    src={type === 'large' ? theWestImageLG : theWestImageSM}
                    alt="covid tracker decorative image"
                />
            </StyledGridTitleItem>

            <StyledGridItem type={type}>
                {data && <ActiveCasesTable data={data} type={type} />}
            </StyledGridItem>

            <StyledGridItem>
                <StyledFlexLinkRow>
                    <StyledLink>
                        Source:
                        <a href="https://covidlive.com.au">covidlive.com.au</a>
                    </StyledLink>
                    <StyledScheduleLink
                        onClick={() => setScheduleOpen(true)}
                        isOpen={scheduleOpen}
                    >
                        View update schedule
                    </StyledScheduleLink>
                </StyledFlexLinkRow>
            </StyledGridItem>

            <UpdateSchedule
                isOpen={scheduleOpen}
                setScheduleOpen={setScheduleOpen}
            />
        </StyledJabTrackerContainer>
    )
}
